import { useState } from "react";
import { useEventListener } from "./use-event-listener";

/**
 * Uses the current online status of the application.
 */
export function useOnlineStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  useEventListener("offline", () => setOnline(false), window);
  useEventListener("online", () => setOnline(true), window);
  return online;
}